import { render, staticRenderFns } from "./PreOrder.vue?vue&type=template&id=70d99598&scoped=true&lang=true&"
import script from "./PreOrder.vue?vue&type=script&lang=js&"
export * from "./PreOrder.vue?vue&type=script&lang=js&"
import style0 from "./PreOrder.vue?vue&type=style&index=0&id=70d99598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d99598",
  null
  
)

export default component.exports